<template>
  <div id="app">
    <Header v-show="!testCompleted" />
    <Test  v-show="!testCompleted" />
    <Pagination  v-show="!testCompleted" />
    <Complete  v-show="testCompleted" />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Test from '@/components/Test.vue'
import Pagination from '@/components/Pagination.vue'
import Footer from '@/components/Footer.vue'
import Complete from '@/components/Complete.vue'
// import jsPDF from 'jspdf'
// import html2canvas from 'html2canvas'
// import jsPDF from 'jspdf'
export default {
  name: 'App',
  components: {
    Test,
    Pagination,
    Header,
    Footer,
    Complete,
  },
  computed: {
    testCompleted() {
      return this.$store.state.testCompleted
    },
  },
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Dosis', sans-serif;
  font-size: 1.2em;
  background-color: white;
  color: #4a4a4a;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
}

#app {
  width: 100%;
  max-width: 700px;
  margin: 50px auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue